// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_ag-4";
export var collapsed = "_ag-1";
export var headerBar = "_ag-0";
export var leftHeaderContent = "_ag-3";
export var subjectContainer = "_ag-2";